import React, { useState } from 'react';
import UserStories from './UserStories';

const initialFormData = {
  firstname: 'Neelakandan',
  lastname: 'Subbiah Pillai',
  age: '28',
  education: 'postgraduate',
  gender: 'male',
  occupation: 'Designer',
  city: 'Trivandrum',
  country: 'India',
  photo: null,
  userStory: 'Neelakandan discovers the brand through visually appealing Instagram ads and influencer collaborations.  Consideration: Engages with the brands content on Instagram, relies on customer reviews, and actively participates in the   brands social media community.',
  goals: 'Stay fashion-forward, discover new styles, and enjoy a convenient shopping experience.  Challenges: Balancing the desire for unique fashion items with budget considerations.',
  frustrations: 'Overwhelming product choices, uncertainty about fit or quality. Delights: Personalized recommendations, a seamless checkout process, and engaging with a vibrant brand community.',
  suggestions: 'none',
  expectations: 'new simple ui',
};

const Task2UserStories = () => {
  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'file' ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
    // Reset the form after submission
    setFormData(initialFormData);
  };

  const handleAddNewUserStory = () => {
    // Handle adding a new user story logic here
    console.log('Adding new user story');
  };

  const handleReset = () => {
    setFormData(initialFormData);
  };

  return (
    <div className='container-xl'>
        <div className='text-start mb-1'><a className='theme-button theme-button-primary' href="/home">Back</a></div>
    <form onSubmit={handleSubmit} className='task-form'>
        <div className='text-center '><i class="bi bi-person-circle display-4 text-theme-pink"></i> </div>

<div className="row">
  <div className="col-md-6 col-lg-4">    
  <label >First Name : </label>
            <input type="text" className="form-control" aria-label="First name" value={formData.firstname} onChange={handleChange} />
            

  </div>
  <div className="col-md-6 col-lg-4">
  <label >Last Name : </label>
            <input type="text" className="form-control" aria-label="Last name" value={formData.lastname} onChange={handleChange} />
           

  </div>
  <div className="col-md-6 col-lg-4">
  <label >Age : </label>
            <input type="text" className="form-control" value={formData.age} onChange={handleChange} />
            

  </div>
  </div>
  <div className="row mt-3">
  <div className="col-sm-6 col-md-4 ">    
  <label>
        Education:</label>
        <select className="form-select w-100" name="education" value={formData.education} onChange={handleChange}>
            <option value="">Select Education</option>
            <option value="none">None</option>
            <option value="school">School</option>
            <option value="graduate">Graduate</option>
            <option value="postgraduate">Post Graduate</option>
            <option value="doctorate">Doctorate</option>
        </select>
        
  </div>

  <div className="col-sm-6 col-md-4">
  <label>
        Gender:</label>
        <select className="form-select w-100" name="gender" value={formData.gender} onChange={handleChange}>
          <option value="">Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>
      
  </div>
  <div className="col-sm-6 col-md-4">
  <label>
        Occupation:</label> 
        <input className="form-control w-100"  type="text" name="occupation" value={formData.occupation} onChange={handleChange} />
                
  </div>
  </div>


  <div className='row mt-3'>
    <div className="col-sm-6 col-md-4 ">
    <label> City:</label>          
            <input className="form-control w-100" type="text" name="city" value={formData.city} onChange={handleChange} />
                
    </div>
    <div className="col-sm-6 col-md-4">
        <label>Country:</label> 
        <input className="form-control w-100" type="text" name="country" value={formData.country} onChange={handleChange} />               
    </div>
     <div className="col-sm-6 col-md-4">
        <label>Photo:</label>
        <input className="form-control w-100"  type="file" name="photo" onChange={handleChange} />
                   
    </div>   
  </div>
  
  <div className='row mt-3'>
    <div className="col-sm-6 col-md-6">
        <label>
        User Story:</label>
        <textarea className="form-control w-100" name="userStory" rows="3" value={formData.userStory} onChange={handleChange}></textarea>           
    </div>
     <div className="col-sm-6 col-md-6">
     <label>
        Goals: </label>
        <textarea className="form-control w-100" name="goals" rows="3" value={formData.goals} onChange={handleChange}></textarea>
                   
    </div>   
  </div>
      
  <div className='row mt-3'>
    <div className="col-sm-6 col-md-6">
    <label>
        Frustrations (Pain points):</label>
        <textarea className="form-control w-100" name="frustrations" rows="3" value={formData.frustrations} onChange={handleChange}></textarea>         
    </div>
     <div className="col-sm-6 col-md-6">

     <label>
        Suggestions:</label>
        <textarea className="form-control w-100" name="suggestions" rows="3" value={formData.suggestions} onChange={handleChange}></textarea>
                   
    </div>   
  </div>
      
      
  <div className='row mt-3'>
    <div className="col-sm-6 col-md-6">
    <label>
        Expectations:</label>
        <textarea className="form-control w-100"  name="expectations" rows="3" value={formData.expectations} onChange={handleChange}></textarea> 
  </div>
  </div>



        <div className='flex-center justify-content-between mt-3'>
            <a className='theme-button bg-theme-pink text-white rounded hover-bg-theme-secondary' type="button"  onClick={handleReset}>Reset</a>
            <span>            
              <a className='theme-button bg-theme-accent text-white rounded hover-bg-theme-secondary me-2' type="button" >Submit</a>
              <a className='theme-button bg-theme-accent text-white rounded hover-bg-theme-secondary ' type="button" onClick={handleAddNewUserStory}>Submit & Add New User Story</a>
            </span>
            
        </div>

    </form>

    <br/><br/><br/><br/><br/>
    <div className='h4 font-secondary pb-2 d-inline-block my-3 text-center border-bottom border-4 border-theme-pink'>Sorted Data from User Stories </div>
    <br/>
    <div className='font-secondary d-inline-block my-3 text-center h6 fw-normal bg-theme-yellow-7 p-2'><b>Share User Story Url</b> : https//doublediamond.ayatacommerce.com/userstory/add/UYUNM340</div>
    <UserStories/>
    <UserStories/>
    <UserStories/>
    <UserStories/>
    </div>
  );
};

export default Task2UserStories;